module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Taipei.3d6d89e4.jpg";